<template>
  <NCollapse class="c-multi-select" default-expanded-names="options">
    <NCollapseItem name="options" :title="title || t('canvasUI.CMultiSelect.titleFallback')">
      <div
        v-for="(item, index) in items"
        :key="index"
        class="c-multi-select__item select-none h-9 flex items-center cursor-pointer rounded-2"
        :class="{
          'mt-1': !!index,
        }"
        @click="toggleItem(item)"
      >
        <NCheckbox
          :checked="isSelected(item.value)"
          class="ml-2"
          size="small"
          :value="item.value"
          @update:value="() => toggleItem(item)"
        />
        <span class="ml-2">{{ item.title }}</span>
        <div class="flex flex-1 justify-end">
          <span class="mr-2 rounded-5 px-2 py-1 c-multi-select__item__counter font-500 text-3 line-height-none">
            {{ item.count }}
          </span>
        </div>
      </div>
    </NCollapseItem>
  </NCollapse>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { NCheckbox, NCollapse, NCollapseItem } from 'naive-ui'
import { useI18n } from 'vue-i18n'
import useThemeVars from '@lib/composables/useThemeVars'

interface Item {
  title: string
  value: string
  count: number
}

type ModelValue = string[]
const emit = defineEmits(['update:modelValue'])
const props = defineProps<{
  title?: string
  items: Item[]
  modelValue: ModelValue
}>()
const { t } = useI18n()
const selectedValuesDict = computed<Record<string, boolean>>(() =>
  props.modelValue.reduce((acc: Record<string, boolean>, value: ModelValue[number]) => {
    acc[value] = true
    return acc
  }, {}),
)
const toggleItem = (item: Item) => {
  const index = props.modelValue.indexOf(item.value)
  if (index === -1) {
    emit('update:modelValue', [...props.modelValue, item.value])
  } else {
    emit(
      'update:modelValue',
      props.modelValue.filter((value: ModelValue[number]) => value !== item.value),
    )
  }
}

const isSelected = (value: string) => !!selectedValuesDict.value[value]
const themeVars = useThemeVars()
</script>

<style scoped>
.c-multi-select__item {
  background-color: v-bind('themeVars.primary6');
}

.c-multi-select__item__counter {
  border: 1px solid v-bind('themeVars.primary');
  color: v-bind('themeVars.primary');
}
</style>
